import { IQProvider } from 'angular';
import TerritoryProvider from './common/services/territory.provider';

export default function(
  $logProvider,
  i18nProvider,
  $httpProvider,
  config,
  ngMetaProvider,
  $compileProvider,
  $locationProvider,
  $qProvider: IQProvider,
  localStorageServiceProvider: angular.local.storage.ILocalStorageServiceProvider,
  territoryProvider: TerritoryProvider
) {
  'ngInject';
  $logProvider.debugEnabled(true);

  $qProvider.errorOnUnhandledRejections(false);

  localStorageServiceProvider
    .setPrefix('fizyweb.paycell')
    .setStorageType('localStorage')
    .setNotify(false, false);

  territoryProvider.init({
    availableTerritories: config.countries.map(country => country.territory)
  });

  i18nProvider.init({
    availableLanguages: config.language.available,
    fallbackLanguage: config.language.fallback,
    preferredLanguage: config.language.preferred
  });

  $httpProvider.defaults.withCredentials = config.http.withCredentials;

  $httpProvider.defaults.headers.get = {
    'Cache-Control': 'no-cache',
    Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
    Pragma: 'no-cache'
  };

  $httpProvider.interceptors.push('languageHttpInterceptor');

  // Add a suffix to all page titles
  ngMetaProvider.useTitleSuffix(true);
  ngMetaProvider.setDefaultTitleSuffix(' | fizy');
  ngMetaProvider.setDefaultTitle('Kalbini Dinle!');
  ngMetaProvider.setDefaultTag('description', 'Fizy - Kalbini Dinle!');
  $compileProvider.aHrefSanitizationWhitelist(
    /^\s*(https?|ftp|mailto|chrome-extension|turkcellmuzik|intent):/
  );

  $locationProvider.html5Mode(true);
}



// WEBPACK FOOTER //
// ./src/app/app.config.ts